var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column-reverse flex-md-row flex-lg-row justify-content-center bg-white shadow h-75 pay-relative"},[_c('portal-target',{staticClass:"pay-button",attrs:{"name":"bottom"}}),_vm._t("body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }